export default __webpack_public_path__ + "static/legal-document-management-solution-3d91cdf7e7278bb7a5774be5ed17b307.png";